import React from 'react'
import PropTypes from 'prop-types'

const CloseIcon = React.memo(({ fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29.707" height="29.707" viewBox="0 0 29.707 29.707">
      <g id="Group_436" data-name="Group 436" transform="translate(0.354 0.354)">
        <line id="Line_22842" data-name="Line 22842" x2="29" y2="29" fill="none" stroke="#fff" strokeWidth="1"/>
        <line id="Line_22843" data-name="Line 22843" x1="29" y2="29" fill="none" stroke="#fff" strokeWidth="1"/>
      </g>
    </svg>
  )
})

CloseIcon.propTypes = {
  fill: PropTypes.string
}

CloseIcon.defaultProps = {
  fill: "#FFF"
}

export {CloseIcon}